import type { FunctionComponent, ReactElement } from 'react';

import classNames from 'classnames';

import styles from './page_block_header.module.css';

type Props = {
  className?: string;
  title: string | ReactElement;
  actionElements?: ReactElement[];
  // TODO: UAD Icons, delete hasUADIcons prop after migration to uad icons
  hasUADIcons?: boolean;
};

const PageBlockHeader: FunctionComponent<Props> = ({
  className,
  title,
  actionElements = [],
  hasUADIcons,
}) => (
  <div className={classNames(styles.header, className)}>
    <h3 className={styles.title}>{title}</h3>
    <div
      className={classNames(styles.controls, hasUADIcons && styles.uad_icons)}
    >
      {actionElements}
    </div>
  </div>
);

export default PageBlockHeader;
